// extracted by mini-css-extract-plugin
export default {"currency":"AnimatedNumber_currency__gbtZv","mark":"AnimatedNumber_mark__lBsI2"};